const spanish = {
  navbar: {
    home: "Inicio",
    about: "Sobre mi",
    work: "Proyectos",
    contact: "Contactame",
  },
  personalInformation: {
    title: "RODRIGO OROZCO",
    subtitle: "[Front-End Developer, Creative Developer, Full-Stack Developer]",
    text: "Hola! si estas buscando un desarrollador web apasionado por el arte, lo creativo y el codigo, estas en el portafolio correcto.",
  },
  textAboutMe: {
    title: "Sobre Mi",
    paragraphOne:
      "Soy desarrollador web Full-Stack y resido en San Juan, Argentina. Poseo conocimientos de Back-End, aunque mi pasión y experiencia se ven orientadas al Front-End, donde hoy en dia me especializo y ejerzo hace más de dos años y medio.",
    paragraphTwo:
      "Busco activamente desarrollarme en mi carrera profesional y me perfilo hacia el desarrollo creativo, ya que me gusta deslumbrar a los usuarios con las posibilidades que ofrece el codigo y el diseño, las cuales son infinitas.",
    paragraphThree:
      "He sido parte de decisiones creativas, consejero y elemento activo de desiciones para mejorar el performance y experiencia tanto de las webs como las apps en las que he trabajado, creando así interfaces responsivas que sean amigables y visualmente placenteras",
  },
  formComponent: {
    field1: "Nombre y Apellido",
    field2: "E-mail",
    field3: "Mensaje",
    button: "Enviar Mensaje!",
    successMessage: "Mensaje enviado con éxito!",
    validation: {
      required: "Este campo es requerido",
      maxLength: "Se excedio la cantidad de caracteres: ",
      email: "Esta dirección de correo es inválida",
    },
  },
  contactPhrase:
    "Vamos a crear el progreso juntos, vos lo imaginas y yo te ayudo a hacerlo realidad",
};

const english = {
  navbar: {
    home: "Home",
    about: "About me",
    work: "Projects",
    contact: "Let's talk",
  },
  personalInformation: {
    title: "RODRIGO OROZCO",
    subtitle: "[Front-End Developer, Creative Developer, Full-Stack Developer]",
    text: "Hello! If you are looking for a web developer who is passionate about art, creativity and code, you are in the right portfolio.",
  },
  textAboutMe: {
    title: "About Me",
    paragraphOne:
      "I am a Full-Stack web developer and I live in San Juan, Argentina. I have knowledge of Back-End, although my passion and experience are oriented to the Front-End, where today I specialize and have been practicing for more than two and a half years.",
    paragraphTwo:
      "I am actively seeking to develop myself in my professional career and I am looking towards creative development, since I like to dazzle users with the possibilities offered by code and design, which are endless.",
    paragraphThree:
      "I have been part of creative decisions, advisor and active element of decisions to improve the performance and experience of both the websites and the apps in which I have worked, thus creating responsive interfaces that are friendly and visually pleasing.",
  },
  formComponent: {
    field1: "Name and last name",
    field2: "E-mail",
    field3: "Message",
    button: "Send Message!",
    successMessage: "Message sent succesfully!",
    validation: {
      required: "This field is required",
      maxLength: "The number of characters is exceeded: ",
      email: "This email address is invalid",
    },
  },
  contactPhrase:
    "Let's create progress together, you imagine it and I help you make it happen",
};

export const textLang = {
  spanish,
  english,
};
